import { render, staticRenderFns } from "./MainProjectSearch.vue?vue&type=template&id=7efedb0d"
import script from "./MainProjectSearch.vue?vue&type=script&lang=js"
export * from "./MainProjectSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports